import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import CharacterCreate from "@/pages/CharacterCreate";
import AppShell from "@/components/AppShell";
import Room from "@/pages/Room";
import City from "@/pages/City";
import Home from "@/pages/Home";
import Jobs from "@/pages/Jobs";
import Housing from "@/pages/Housing";
import Shop from "@/pages/Shop";
import Social from "@/pages/Social";
import Chat from "@/pages/Chat";
import Profile from "@/pages/Profile";
import Leaderboard from "@/pages/Leaderboard";
import Store from "@/pages/Store";
import Advertise from "@/pages/Advertise";
import AdminAds from "@/pages/AdminAds";
import AdminLeads from "@/pages/AdminLeads";
import LeadCapture from "@/pages/LeadCapture";
import HustlerRewards from "@/pages/HustlerRewards";
import Contests from "@/pages/Contests";
import Businesses from "@/pages/Businesses";
import Betting from "@/pages/Betting";
import Investments from "@/pages/Investments";
import Furnish from "@/pages/Furnish";
import Wardrobe from "@/pages/Wardrobe";
import AdminRewards from "@/pages/AdminRewards";
import AdminEconomics from "@/pages/AdminEconomics";
import PaymentCallback from "@/pages/PaymentCallback";
import AuthCallback from "@/pages/AuthCallback";

function Gate({ children }) {
  const { user, character, ready } = useAuth();
  if (!ready || user === null) {
    return (
      <div className="h-[100dvh] flex items-center justify-center bg-[#F8FAFC] text-[#16A34A] font-display text-2xl">
        loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  if (!character) return <Navigate to="/create" replace />;
  return children;
}

function AppRoutes() {
  const location = useLocation();
  // Process Google OAuth return FIRST (synchronously) to avoid races with Gate.
  if (location.hash && location.hash.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
          <Route path="/create" element={<CharacterCreate />} />
          <Route path="/admin/ads" element={<AdminAds />} />
          <Route path="/admin/leads" element={<AdminLeads />} />
          <Route path="/advertise" element={<Advertise />} />
          <Route path="/promote" element={<LeadCapture />} />
          <Route path="/admin/rewards" element={<AdminRewards />} />
          <Route path="/admin/economics" element={<AdminEconomics />} />
          <Route element={<Gate><AppShell /></Gate>}>
            <Route path="/room" element={<Room />} />
            <Route path="/city" element={<City />} />
            <Route path="/home" element={<Home />} />
            <Route path="/jobs" element={<Jobs />} />
            <Route path="/map" element={<Housing />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/social" element={<Social />} />
            <Route path="/chat/:id" element={<Chat />} />
            <Route path="/me" element={<Profile />} />
            <Route path="/wardrobe" element={<Wardrobe />} />
            <Route path="/player/:id" element={<Profile />} />
            <Route path="/leaderboard" element={<Leaderboard />} />
            <Route path="/store" element={<Store />} />
            <Route path="/rewards" element={<HustlerRewards />} />
            <Route path="/contests" element={<Contests />} />
            <Route path="/businesses" element={<Businesses />} />
            <Route path="/viewing-centre" element={<Betting />} />
            <Route path="/invest" element={<Investments />} />
            <Route path="/furnish" element={<Furnish />} />
            <Route path="/payment/callback" element={<PaymentCallback />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" theme="dark" richColors closeButton
          toastOptions={{ style: { background: "#ffffff", border: "1px solid #e2e8f0", color: "#0F172A", fontFamily: "Outfit, sans-serif" } }} />
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
